import React, { useState } from 'react';
import { authProvider } from '../../../services/Security';
import { Grid, Tab, Tabs } from '@material-ui/core';
import '../../../scss/UVP.scss';
import { UVPReturns } from './UVPReturns';
import { UVPReturnsBatch } from './UVPReturnsBatch';
import { UVPReturnsResults } from './UVPReturnsResults';

export const UVPReturnsTabs = ({errorToast, successToast}) => {
    const [operatorId, setOperatorId] = useState<any>();
    const [selectedBatch, setSelectedBatch] = useState<any>();
    const [selectedTab, setSelectedTab] = useState<number>(0);

    window.addEventListener('message', event => {
        // IMPORTANT: check the origin of the data!
        if(!event.data) return;
        var data = JSON.parse(event?.data);
        authProvider.setToken(data?.token)
        setOperatorId(data?.operatorId)
        // if (event.origin === 'https://your-first-site.example') {
        //     // The data was sent from your site.
        //     // Data sent with postMessage is stored in event.data:
        // } else {
        //     // The data was NOT sent from your site!
        //     // Be careful! Do not use it. This else branch is
        //     // here just for clarity, you usually shouldn't need it.
        //     return;
        // }
    });

    const handleChange = (e, tab) => {
        setSelectedTab(tab)
    }

    return (
        <React.Fragment>
            <Grid style={{backgroundColor: "white"}}>
                <Tabs className='uvp-tab-bar' style={{backgroundColor:"#f5f5f5", marginBottom: "20px"}} value={selectedTab} onChange={handleChange} TabIndicatorProps={{ style: { backgroundColor: "#3F8A3D", height: "4px" } }}>
                    <Tab className='uvp-tabs' label="Batch Summary" style={{backgroundColor: selectedTab === 0 ? "white" : "#E0E0E0"}}></Tab>
                    <Tab className='uvp-tabs' label="Batch Detail" disabled={!selectedBatch} style={{backgroundColor: selectedTab === 1 ? "white" : "#E0E0E0"}}></Tab>
                </Tabs>
                {selectedTab === 0 ?
                    <UVPReturns
                        errorToast={errorToast}
                        successToast={successToast}
                        setSelectedBatch={data => {
                            setSelectedBatch(data);
                            setSelectedTab(1)
                        }}
                        operatorId={operatorId} /> :
                    selectedBatch.status === "Processed" ?
                        <UVPReturnsResults
                            errorToast={errorToast}
                            successToast={successToast}
                            selectedBatch={selectedBatch} /> :
                        <UVPReturnsBatch
                            errorToast={errorToast}
                            successToast={successToast}
                            selectedBatch={selectedBatch}
                            setSelectedTab={setSelectedTab} />
                }
            </Grid>
        </React.Fragment>
    );
}
